import { editStoreBuilder } from '@/main/store/pages/edit/builder';
import { UPDATE } from '@/main/store/listEditTypes';
import { Status } from '@/main/store/@types/page';
import { writeAction } from '@/main/store/actionsFunctions';
import { router } from '@/main/router';
import { convertToObjects } from '@/main/utils/table';

import { DEPENDENT_TABLES, NAME as name, CRUMB_LABEL_EDIT, POLOZKY,PR_INVOICE } from '../constants';
import { apiProvider } from '../api';
import { editMutations, types } from './types';


const edit = {
	PaymentMethod: null as number | null,
	Amount: 0 as number,
	TransactionDate: null as Date | null,
	ReferenceInvoiceNo: null as string | null,
	TransactionStatus: null as number | null,
	PrijemkaId: 0 as number,
	PRInvoicePaymentId: null as number | null,
	PrInvoiceId: null as number | null,
	InvoiceNumber: null as string | null,
	TotalPrice: null as number | null,
	OutStandingAmount: 0 as number,
	IsPaymentDone: false,
	GstAmount: null as number | null,
	TotalPriceWithGst: 0 as number,
	VatAmount: null as number | null,
	TotalPriceWithVat: 0 as number,
	ZakazkaStav: null as number | null,
	ZakazkalistId: null as number | null,
	DodavatelId: null as number | null,
	DodavatelIdText: null as string | null,
	Discount: null as number | null,
	SupplierInvoiceNumber: null as string | null,
	CreatedBy: null as number | null,
	BillToWareHouseName: null as string | null,
	ShipToWareHouseName: null as string | null,
};

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_EDIT,
	dropdownList: {
		PlatbaPzn: [],
		Statuses: [],
	},
	edit,
	localState: {},
	depTableNames: DEPENDENT_TABLES,
	depTableSettings: {
		[POLOZKY]: {
			isEditable: true,
			columns: {
				UNIT_COST_PRICE: { isEditable: true },
				DISCOUNT: {isEditable: true},
				REMARK:{isEditable: true},
			},
			filter(state) {
				return {
					PrInvoicePaymentId: state.edit.PRInvoicePaymentId,
				};
			},
		},
		[PR_INVOICE]: {
			isEditable: true, 
			filter(state) { 
				return { 
					LoggedUserId: state.props.filter.LoggedUserId,
					FromDate: state.props.filter.FromDate,
					ToDate: state.props.filter.ToDate,

				};
			} 
		},
	},
	extraActions: {
		async [UPDATE]({ commit, dispatch, state }, data: { id: string | number, goBack: boolean }) {
			const polozky = convertToObjects(state.dependentTables.Polozky).map((polozka, idx) => {
				if (polozka.ZaznamId < 0) {
					polozka.ZaznamId = null;
				}
				polozka.NC = polozka.UnitCostPrice;
				return ({ ...polozka, prInvoicePaymentID: data.id, SortZlPol: idx });
			});
			const updatedEntity = {
				...state.edit,
				Polozky: polozky,
			};
			await writeAction(
				state,
				commit,
				dispatch,
				apiProvider.updateEntity(data.id, updatedEntity),
				false,
			);
			if (state.status === Status.ok) {
				commit(types.mutations.COMPUTE_ROWS_HASH);
			}
			if (data.goBack) {
				router.back();
			}
			return state.status === Status.ok ? updatedEntity : null;
		},
	},
	extraGetters: {},
	extraMutations: {
		[editMutations.ND_PRIJEMKA_DODAVATEL_SELECT_MAPPER](state, { data }) {
			state.edit.DodavatelId = data.value;
			state.edit.DodavatelIdText = data.text;
		},
		[editMutations.ND_PRINVOICE_SELECT_MAPPER](state, { data }) {
			state.edit.PrInvoiceId = data.PrijemkaId;
			state.edit.PrijemkaId = data.PrijemkaId;
			state.edit.InvoiceNumber = data.PrijemkaNr;
		},
		[editMutations.PRINVOICE_INVOICE_SELECT_MAPPER](state, { data }) {
			state.edit.PrInvoiceId = data.PrijemkaId;
			state.edit.PrijemkaId = data.PrijemkaId;
			state.edit.InvoiceNumber = data.PrijemkaNr;
			state.edit.TotalPrice = data.TotalPrice;
			state.edit.OutStandingAmount = data.OutstandingAmount;
			state.edit.TotalPriceWithGst = data.TotalPriceWithGst;
			state.edit.GstAmount = data.GstAmount;
			state.edit.TotalPriceWithVat = data.TotalPriceWithVat;
			state.edit.VatAmount = data.VatAmount;
			state.edit.DodavatelId = data.DodavatelId;
			state.edit.DodavatelIdText = data.Supplier;
			state.edit.SupplierInvoiceNumber = data.DodFaktNr;
			state.edit.BillToWareHouseName = data.BillToWareHouseName;
			state.edit.ShipToWareHouseName = data.ShipToWareHouseName;
		},
	},
	props: {
		mode: null,
		filter: {
			prijemkaId: null as number | null,
			paymentId: null as number | null,
			prInvoicePaymentID: null as number | null,
			DodavatelId: null as number | null,
			PrijemkaPfx: null as null | string,
			PrijemkaNr: null as null | number,
			DodListNr: null as null | string,
			DodFaktNr: null as null | string,
			SupplierName: null as null | string,
			NdprijemPzn: null as null | number,
			PaymentMode: null as null | number,
			StatusId: null as null | number,
			PROrderId: null as number | null,
			PRInvoiceNr: null as number | null,
			PRInvoicePfx: null as null | string,
			FromDate: null as null | string,
			ToDate: null as null | string,
			LoggedUserId: null as number | null,
		},
	},
});
